import { API_DEMO_PRESENTATION_URL } from "../Utilities/Helper";
import { post } from "./AxiosService";

const Url = API_DEMO_PRESENTATION_URL;

// Alert the team that a group leader registered a new account. Fire-and-forget:
// the caller should never let a failure here affect the registration flow.
export function notifyGroupLeaderSignup(data) {
  return post(`${Url}group_leader_signup_notification`, data).then(
    (res) => res.data
  );
}
